import { useNavigate } from "react-router-dom";
import type * as L from "leaflet";

import { useEmission } from "src/hooks";
import { useScenario } from "src/hooks/useScenario";
import { EmissionType } from "src/types";
import { isReadOnly } from "src/utils/permission.utils";
import { PointSourceControlOnMap } from "src/components/on-map/PointSourceControlOnMap";

interface Props {
  map: L.Map;
  controlContainer: Element | null;
  params: {
    caseId: string;
    scenarioId: string;
    emissionId: string;
    pointSourceId?: string;
  };
}

export function PointSourceEmissionDrawOnMap(props: Props) {
  const { params } = props;
  const navigate = useNavigate();
  const { data: scenario } = useScenario(params.scenarioId);
  const { data: emission } = useEmission(params.scenarioId, params.emissionId, EmissionType.POINT_SOURCE);

  /**
   * Functions
   */

  function handleDraw(point: L.LatLngLiteral) {
    const url = `/cases/${params.caseId}/scenarios/${params.scenarioId}/emissions/point-source/${params.emissionId}/point-sources/new`;
    navigate(url, { state: { point } });
  }

  return render();

  function render() {
    if (!scenario || !emission) return null;

    return (
      <PointSourceControlOnMap
        map={props.map}
        emission={emission}
        controlContainer={props.controlContainer}
        disabled={
          isReadOnly(scenario.permissions.updateEmission) ||
          // no drawing when create page is active
          params.pointSourceId === "new"
        }
        onDraw={handleDraw}
      />
    );
  }
}
